import { session } from './session';
import { ROLE } from '../config/Role';

export const isAuthorized = (authorizedRoles: Array<ROLE>): boolean => {
    if (!session.isAuthenticated() || !session.data) return false;

    if (!authorizedRoles.length) return true;

    return (
        authorizedRoles.findIndex((x) => session.data?.roles.includes(x)) > -1
    );
};
